import { TranslatedText } from "@/components/common/text";
import { Warning } from "@/components/common/svgs";
import { cn } from "@/utils/css";

export const ErrorComponent = ({ className }) => {
    return (
        <div className={cn("w-full h-full flex flex-col items-center justify-center text-center", className)}>
            <div className="mb-2">
                <Warning />
            </div>
            <div className="text-cm-p-text-primary text-sm font-semibold mb-1">
                <TranslatedText>Issue with loading the data.</TranslatedText>
            </div>
            <div className="text-cm-p-text-secondary text-xs max-w-[252px]">
                If the problem persists, please report it using the feedback button.
            </div>
        </div>
    );
};
